"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _propTypes = _interopRequireDefault(require("prop-types"));

var _react = _interopRequireWildcard(require("react"));

var _CardStyled = require("./Card-styled");

var _Card = require("./Card");

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {}; if (desc.get || desc.set) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var CardImage = function CardImage(_ref) {
  var children = _ref.children,
      src = _ref.src,
      caption = _ref.caption,
      alt = _ref.alt,
      other = _objectWithoutProperties(_ref, ["children", "src", "caption", "alt"]);

  var cardContext = (0, _react.useContext)(_Card.CardContext);

  function getFigcaption(shaped) {
    if (!shaped && caption) {
      return _react.default.createElement(_CardStyled.StyledCardImageCaption, null, caption);
    }
  }

  return _react.default.createElement(_CardStyled.StyledCardImageWrap, _extends({}, cardContext, other), _react.default.createElement(_CardStyled.StyledCardImage, _extends({}, cardContext, {
    src: src,
    alt: alt
  })), getFigcaption(cardContext.shaped));
};

CardImage.propTypes = {
  /** The HTML src property of the CardImage. */
  src: _propTypes.default.string,

  /** The text content of the figure caption on the CardImage. */
  caption: _propTypes.default.string,

  /** The HTML alt property of the component. */
  alt: _propTypes.default.string
};
CardImage.defaultProps = {};
CardImage.displayName = 'CardImage';
var _default = CardImage;
exports.default = _default;